export const createCohortData = function (
  arrData,
  { startDate, endDate },
  average
) {
  const showPeriod = 24;
  const cohortTable = [];

  let allDates = Object.keys(arrData);
  if (startDate || endDate) {
    const from = dateFormat(startDate);
    const to = dateFormat(endDate);

    if (check(allDates, to, from)) {
      return cohortTable;
    }

    const indF = allDates.indexOf(from) !== -1 ? allDates.indexOf(from) : 0;
    const indT =
      allDates.indexOf(to) !== -1 ? allDates.indexOf(to) + 1 : allDates.length;
    allDates = allDates.slice(indF, indT);
  }

  if (allDates.length > showPeriod) {
    const cut = allDates.length - showPeriod;
    allDates = allDates.slice(cut);
  }

  let costSum = 0;
  let initSum = 0;

  allDates.map(date => {
    const dateData = arrData[date];
    costSum += dateData.marketingCost;
    initSum += dateData.initialNumOfCustomers;

    const tempArr = [];
    dateData.data.map(val => {
      tempArr.push(
        val
          ? val
          : {
              accumulatedCollection: 0,
              roi: 0
            }
      );
      return true;
    });
    cohortTable.push([
      date,
      dateData.marketingCost,
      dateData.initialNumOfCustomers,
      ...tempArr
    ]);
    return true;
  });
  if (cohortTable.length) {
    cohortTable.push([average, costSum, initSum]);
  }

  return cohortTable;
};

export const createReqBody = (channel, size, plan) => {
  return {
    channel: channel[0] ? channel : '*',
    plan: plan[0] ? plan : '*',
    companySize: size[0] ? size : '*'
  };
};

const dateFormat = date => {
  return [...date.slice(6), '-', ...date.slice(0, 2), '-', '01'].join('');
};

const check = (dates, to, from) => {
  if (new Date(to).getTime() < new Date(dates[0]).getTime()) {
    return true;
  }
  if (new Date(from).getTime() > new Date(dates[dates.length - 1]).getTime()) {
    return true;
  }
  return false;
};

export const createSaveList = location => {
  const query = new URLSearchParams(location.search);
  const loadList = {
    unit: query.get('unit') + '' !== 'null' ? query.get('unit') : '%',
    date:
      query.get('dateStart') + '' !== 'null'
        ? {
            startDate: query.get('dateStart'),
            endDate: query.get('dateEnd')
          }
        : { startDate: null, endDate: null },
    channel:
      query.get('channel') + '' !== '' ? query.get('channel').split(',') : [],
    size: query.get('size') + '' !== '' ? query.get('size').split(',') : [],
    plan: query.get('plan') + '' !== '' ? query.get('plan').split(',') : []
  };
  return loadList;
};
